import React, { useContext, useEffect, useRef, useState } from "react";
import { useBookingData, useNextEngagement } from "./store";
import Reschedule from "modules/dashboards/actionables/Reschedule";
import SoftBadge from "modules/common/SoftBadge";
import { CLINIC_RECEPTIONINST_FLAG, currentUser, doctor, getCurrentUserRole, getFormattedDate, weeklyCall } from "modules/utilities/utility";
import FeedbackForm from "modules/dashboards/feedback_form/FeedbackForm";
import PrescriptionFeedbackForm from "modules/dashboards/feedback_form/PrescriptionFeedback";
import { Pagination } from "antd";
import useDoctorDashboardStore from "modules/all_doctor_dashboard/store";
import moment from "moment";
import { isEmpty } from "lodash";
import { useCustomer, useDoctorSlot } from "modules/dashboards/actionables/store";
import InterventionBooking from "modules/dashboards/feedback_form/InterventionBooking";
import NewDispositionFlow from "modules/dashboards/feedback_form/NewDispositionFlow";
import SlotBookingMedical from "modules/dashboards/feedback_form/SlotBookingMedical";
import SlotCancellationCanvas from "modules/slot_cancellation/SlotCancellationCanvas";
import { ActiveEngagement } from "modules/dashboards/actionables/ShowEngagement";
import LeadSlotDisposition from "./LeadSlotDisposition";
import CustomerComplaintBookingDesposition from "modules/dashboards/feedback_form/CustomerComplaintBookingDesposition";
import AdhocCallDisposition from "./AdhocCallDisposition";
import { useCallingStore } from "modules/navbar/top/store/store";
import secureLocalStorage from "react-secure-storage";
import MedicineContext from "modules/dashboards/feedback_form/MedicineContext";
import { CustomerProps } from "modules/dashboards/actionables/ShowCustomer";
import ClinicSlotDisposition from "modules/dashboards/feedback_form/ClinicSlotDisposition";

function RecentOrder({ setBooking, orders }) {
  const { voitekkCalling, exotelCalling, knowlarityCalling, exotelAmeyoCalling, agamiCalling, ubonaCalling } = useCallingStore();
  const { fetchDoctorAppointmentData } = useDoctorDashboardStore();
  const [slotBookingPayload, setSlotBookingPayload] = useState({})
  const [formData, setFormData] = useState({ callResponse: null, comments: null, });

  const { nextEngagementData, nextEngagements } = useNextEngagement();
  const prevCustomerIdRef = useRef(null);
  const { markedSlot } = useDoctorSlot();
  const currentUrl = window.location.href.split("/");
  const { setActiveEngagement, setActiveEngagamentData } = useContext(ActiveEngagement);
  const { caseId, data, setData, customer, nextCall } = useContext(CustomerProps)
  const [activeOrder, setActiveOrder] = useState(0);
  let showTicketInfo = true;
  const leadAgent = ["lead_agent", 'chat_call_agent'];

  useEffect(() => {
    if (currentUrl.includes("next-call")) {
      if (nextEngagementData?._id) {
        setActiveEngagement(nextEngagementData._id);
        setActiveEngagamentData(nextEngagementData);
      }
      return;
    }
    if (data?.length) {
      const index = activeOrder <= data.length-1  ? activeOrder : 0;
      setActiveEngagement(data[index]._id);
      setActiveEngagamentData(data[index]);
    }
  }, [activeOrder, data, nextEngagementData]);

  useEffect(() => {
    if (caseId !== prevCustomerIdRef.current) {
      prevCustomerIdRef.current = caseId;
      if (currentUrl.includes("next-call")) {
        isEmpty(nextEngagementData) && nextEngagements();
      } else {
        if (doctor.includes(getCurrentUserRole())) {
          fetchDoctorAppointmentData(caseId, setData);
        }
      }
    }
  }, [caseId]);

  useEffect(() => {
    if (markedSlot && data.length) {
      setData((prevData) => { return prevData.unshift() });
    }
  }, [markedSlot]);
  useEffect(()=>{
    if(voitekkCalling || exotelCalling || knowlarityCalling || exotelAmeyoCalling || agamiCalling || ubonaCalling ){
      setData(prev => {
        const adhocCall = {
          user_id: secureLocalStorage.getItem("id"),
          reminder_date: moment().toISOString(),
          status: "active",
          is_finished: false,
          tag: "ADHOC_CALL",
          is_valid: true,
          is_slot_booked: false,
          createdAt: moment().toISOString(),
          updatedAt: moment().toISOString(),
        };
        return isEmpty(prev) ? [adhocCall] : prev.some(eng => moment(eng.reminder_date).isBefore(moment().endOf('day'))) ? prev.sort((engA, engB)=> new Date(engA.reminder_date) - new Date(engB.reminder_date)) : [...prev, adhocCall].sort((engA, engB)=> new Date(engA.reminder_date) - new Date(engB.reminder_date));
      });
    }
    if(!voitekkCalling && !exotelCalling && !knowlarityCalling && !exotelAmeyoCalling && !agamiCalling && !ubonaCalling){
      setData(prev => {
        return prev.filter(eng=> eng.tag !== 'ADHOC_CALL')
      })
    }
  },[voitekkCalling, exotelCalling, knowlarityCalling, exotelAmeyoCalling, agamiCalling, ubonaCalling]);

  const formSelection = (week, selectedOrder) => {
    let relatedTag = orders?.length == 1 && ["shipped", "shipping_pending", "in_progress"].includes(orders[0]?.status) && week == "SLOT_BOOKING" ? "Onboarding Call" : week;
        if ((selectedOrder.request_type === "lead_cold_slot"|| week === 'SLOT_BOOKING') && leadAgent.includes(currentUser)) { relatedTag = "Slot Booking Lead"; }

    const userLevel = selectedOrder?.rep?.level;
    if (userLevel === 2 && week === 'SLOT_BOOKING' && !leadAgent.includes(currentUser)) {relatedTag = "PC Slot"}
    if(CLINIC_RECEPTIONINST_FLAG && relatedTag === 'PC Slot') {relatedTag = "Clinic Slot"}

    switch (relatedTag) {
      case "Prescription Call":
      case "PC Slot":
        return (
          <NewDispositionFlow
            week={selectedOrder.tag}
            id={selectedOrder._id}
            bookingId={selectedOrder.booking_reference_id}
            orders={orders}
            customerId={customer.id}
            setData={setData}
            setBooking={setBooking}
            customer ={customer}
          />
        );
      case "Week 1":
      case "kit_not_started":
      case "scalpie_update":
        return (
          <PrescriptionFeedbackForm
            week={selectedOrder.tag}
            id={selectedOrder._id}
            bookingId={selectedOrder.booking_reference_id}
            customer ={customer}
          />
        );
      case "Clinic Slot":
        return (
          <ClinicSlotDisposition
            week="Clinic Slot"
            id={selectedOrder._id}
            bookingId={selectedOrder.booking_reference_id}
            customer ={customer}
          />
        );
      case "Intervention Call":
      case "Paid Call":
      case "Direct Call":
      case "Follow Up Intervention":
      case "499 Call":
      case "Clinic Appointment":
      case "Offline Appointment":
        return (
          <MedicineContext>
            <InterventionBooking
              caseId={selectedOrder.case_id}
              bookingId={selectedOrder?._id}
              orders={orders}
              callType={relatedTag}
              showTicketInfo={showTicketInfo}
              syntheticId={customer}
            setSlotBookingPayload={setSlotBookingPayload}
            engTicketId={selectedOrder?.ticket_id}    
              customer ={customer}
            />
         </MedicineContext>
        );
      case "SLOT_BOOKING_MEDICAL":
        return (
          <SlotBookingMedical
            week={selectedOrder?.tag}
            customerId={customer.id}
            orders={orders}
            data={selectedOrder}
            bookingId={selectedOrder?._id}
            id={selectedOrder?._id}
            setData={setData}
            setBooking={setBooking}
            setActiveOrder={setActiveOrder}
            customer ={customer}
          />
        );
      case "Onboarding Call":
        return (
          <NewDispositionFlow
            week={relatedTag}
            id={selectedOrder._id}
            bookingId={selectedOrder.booking_reference_id}
            orders={orders}
            customerId={customer.id}
            setData={setData}
            setBooking={setBooking}
            customer ={customer}
          />
        );
      case "Slot Booking Lead":
        return (
          <LeadSlotDisposition
            week={relatedTag}
            customerId={customer.id}
            bookingId={selectedOrder?._id}
            id={selectedOrder?._id}
            setData={setData}
            setBooking={setBooking}
            customer ={customer}
          />
        );
      case "CUSTOMER_COMPLAINT_BOOKING":
          return (        
            <CustomerComplaintBookingDesposition
              week={relatedTag}
              customerId={customer.id}
              bookingId={selectedOrder?._id}
              id={selectedOrder?._id}
              setData={setData}
              setBooking={setBooking}
              caseDetails={selectedOrder}
              customerData={selectedOrder}
              setFormData={setFormData}
              data={selectedOrder}
              customer ={customer}
            />
          );
      case "ADHOC_CALL": return (<AdhocCallDisposition customerId={customer.id} setData={setData} />);
      default:
        return (
          <FeedbackForm
            orderCount={selectedOrder?.order?.count}
            setBooking={setBooking}
            data={selectedOrder}
            week={selectedOrder?.tag}
            id={selectedOrder?._id}
            bookingId={selectedOrder?.booking_reference_id}
            customerId={customer.id}
            setData={setData}
            orders={orders}
            customer ={customer}
          />
        );
    }
  };

  const handleOrderChange = (number) => {
    setActiveOrder(number - 1);
  };

  return (data && data?.length) || !isEmpty(nextEngagementData) ? (
    <div className="d-flex justify-content-center h-100">
      {nextCall ? (
        <div className="d-flex align-items-center justify-content-center">
          <div className="flex-fill d-flex flex-column gap-3 align-items-center justify-content-center ">
            <div className="d-flex gap-2 justify-content-between">
              {nextEngagementData ? (
                !isEmpty(nextEngagementData) && (
                  <>
                    <SoftBadge bg="primary" className="fs-1">
                      {nextEngagementData?.tag
                        ?.replaceAll("_", " ")
                        .toUpperCase()}
                    </SoftBadge>
                    {nextEngagementData?.is_slot_booked && (
                      <SoftBadge bg="primary" className="fs-1">
                        SLOT BOOKING
                      </SoftBadge>
                    )}
                    {nextEngagementData?.from_crm && (
                      <SoftBadge bg="primary" className="fs-1">
                      Priority
                      </SoftBadge>
                    )}
                    {nextEngagementData?.batch && (
                      <SoftBadge bg="primary" className="fs-1">
                        {nextEngagementData?.batch}
                      </SoftBadge>
                    )}
                  </>
                )
              ) : (
                <div>Please wait</div>
              )}
            </div>
            {nextEngagementData && (
              <SoftBadge bg="secondary" className="fs-1 text-black">
                {getFormattedDate(nextEngagementData?.reminder_date)}
              </SoftBadge>
            )}
            <div className="w-100 d-flex gap-3">
              {weeklyCall.includes(nextEngagementData?.tag) && (
                <Reschedule
                  id={nextEngagementData?._id}
                  dueDate={nextEngagementData?.due_date}
                  item={nextEngagementData}
                />
              )}
              {formSelection(nextEngagementData?.tag, nextEngagementData)}
            </div>
          </div>
        </div>
      ) : (
        <div
          className="d-flex flex-column align-items-center justify-content-center h-100"
          style={{ width: "85%" }}
        >
          {data[activeOrder] && (
            <div className="d-flex flex-column justify-content-between align-items-center h-100">
              <div className="flex-fill d-flex flex-column gap-3 p-3 mt-n1 rounded align-items-center justify-content-center w-100 border border-primary shadow">
                <div className="d-flex gap-2 flex-wrap justify-content-center w-100 align-items-center">
                  <SoftBadge
                    bg="primary"
                    className="mw-100 text-wrap word-break"
                  >
                    <span style={{ fontSize: 13 }}>
                      {data[activeOrder]?.payment_status == "free"
                        ? "Direct Call"
                        : data[activeOrder]?.tag?.replace("_", " ")}
                    </span>
                    {data[activeOrder]?.request_type==="lead_cold_slot"?<span className="ms-1">Cold Call</span>:null}
                  </SoftBadge>
                  {(["SLOT_BOOKING", "chat_slot_booking"].includes(data[activeOrder]?.tag) && data[activeOrder]?.unanswered_count &&
                    leadAgent.includes(currentUser)) ? (
                      <SoftBadge
                        bg="danger"
                        className="mw-100 text-wrap word-break"
                      >
                        <span style={{ fontSize: 13 }}>
                          Reattempt : {data[activeOrder]?.unanswered_count}
                        </span>
                      </SoftBadge>
                    ):null}
                  <SoftBadge
                    bg="danger"
                    className="mw-100 text-wrap text-break word-break"
                  >
                    {data[activeOrder]?.tag === "SLOT_BOOKING_MEDICAL" &&
                      data[activeOrder]?.unanswered_count !== 0 && (
                        <span style={{ fontSize: 13 }}>
                          Last Attempt :{" "}
                          {moment(data[activeOrder]?.updatedAt).format(
                            "YYYY/MM/DD HH:mm:ss"
                          )}
                        </span>
                      )}
                  </SoftBadge>
                  {data[activeOrder]?.slot_type !== "false" &&
                    data[activeOrder]?.slot_type && (
                      <SoftBadge
                        bg="info"
                        className="mw-100 text-wrap text-break word-break"
                      >
                        <span style={{ fontSize: 13 }}>
                          {data[activeOrder]?.slot_type}
                        </span>
                      </SoftBadge>
                    )}

                  {data[activeOrder].batch && (
                    <SoftBadge
                      bg="info"
                      className="mw-100 text-wrap word-break"
                    >
                      <span style={{ fontSize: 13 }}>
                        Batch: {data[activeOrder].batch}
                      </span>
                    </SoftBadge>
                  )}
                </div>
                {data[activeOrder].is_slot_booked && (
                  <SoftBadge>
                    <span style={{ fontSize: 13 }}>Slot Booking</span>
                  </SoftBadge>
                )}
                <SoftBadge
                  bg="secondary"
                  className="text-black mw-100 fw-bold text-wrap word-break"
                >
                  {getFormattedDate(data[activeOrder].reminder_date)}
                </SoftBadge>
                <div className="w-100 d-flex justify-content-around gap-1">
                  {!['ADHOC_CALL'].includes(data[activeOrder].tag)&&<>
                    {data[activeOrder].tag !== "SLOT_BOOKING" ? !doctor.includes(getCurrentUserRole()) && (
                      <Reschedule
                      id={data[activeOrder]._id}
                      dueDate={data[activeOrder].reminder_date}
                      item={data[activeOrder]}
                      />
                    )
                    : <SlotCancellationCanvas data={data[activeOrder]} />}
                  </>}
                  {formSelection(data[activeOrder].tag, data[activeOrder])}
                </div>
              </div>
              <Pagination
                pageSize={1}
                current={activeOrder + 1}
                total={data.length}
                onChange={handleOrderChange}
                showLessItems={true}
                style={{ textAlign: "center", marginTop: "5px" }}
                size="small"
              />
            </div>
          )}
        </div>
      )}
    </div>
  ) : (
    <div style={{ height: "11.6rem" }}>
      <SoftBadge
        className="h-100 w-100 word-break text-wrap fs-1 d-flex align-items-center justify-content-center"
        bg="secondary"
      >
        No Slot available
      </SoftBadge>
    </div>
  );
}

export default RecentOrder;